class AddressEntryFormController {
    constructor($q, moveFocus, addressService, fulfilmentService, addressEntryModes) {
        this.$q = $q;
        this.moveFocus = moveFocus;
        this.addressService = addressService;
        this.fulfilmentService = fulfilmentService;
        this.addressEntryModes = addressEntryModes;
    }

    set addressEntryMode(mode) {
        this.entryMode = mode;
        if (this.onSetEntryMode) {
            this.onSetEntryMode({ mode });
        }
    }

    get addressEntryMode() {
        return this.entryMode;
    }

    $onInit() {
        this.shouldResetMode = this.shouldResetMode !== undefined ? this.shouldResetMode : true;
        this.shouldFocusInitially = this.shouldFocusInitially !== undefined ? this.shouldFocusInitially : true;
        this.clearInput();
        if (!this.initialAddress) {
            this.addressEntryMode = this.addressEntryModes.search;
        }
        this.address = null;

        if (this.shouldFocusInitially) {
            this.moveFocus(`#address-${this.inputId}`);
        }
    }

    getItemText(item) {
        return item.Text;
    }

    $onChanges(changes) {
        if (changes.initialAddress && this.initialAddress) {
            this.setEntryMode(this.addressEntryModes.manual);
        }
    }

    clearInput() {
        this.autocompleteText = this.addressQuery ? this.addressQuery.AddressText : '';
    }

    saveSearchedAddress(address) {
        if (this.onSaveAutoAddress) {
            this.onSaveAutoAddress({ address });
        }
        if (!this.shouldRetainInput) {
            this.clearInput();
        } else {
            this.autocompleteText = address.Text;
        }
    }

    saveManualAddress(address) {
        if (address.suburbId && address.suburbId > 0) {
            if (this.onSaveManualAddress) {
                this.$q.when(this.onSaveManualAddress({ address })).then(() => {
                    if (this.shouldResetMode) {
                        this.setEntryMode(this.addressEntryModes.search);
                    }
                });
            }
            if (!this.shouldRetainInput) {
                this.clearInput();
            }
        }
    }

    setEntryMode(mode) {
        this.addressEntryMode = mode;
        if (mode === this.addressEntryModes.search) {
            this.moveFocus(`#address-${this.inputId}`);
        }
        this.address = null;
    }
}

const addressEntryFormComponentDefinition = {
    bindings: {
        inputId: '@',
        addressQuery: '<?',
        showSubmit: '=?',
        messageOnError: '@?',
        shouldFocusInitially: '<?',
        shouldResetMode: '<?',
        shouldRetainInput: '<?',
        onSaveAutoAddress: '&?',
        onSaveManualAddress: '&?',
        onManualAddressChange: '&?',
        onSetEntryMode: '&?',
        initialAddress: '<?',
    },
    controller: ['$q', 'MoveFocus', 'AddressService', 'FulfilmentService', 'AddressEntryModes', AddressEntryFormController],
    template: require('./address-entry-form.component.html').trim(),
};

module.exports = {
    AddressEntryFormController,
    addressEntryFormComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/address/address-entry-form.component.js